if (!customElements.get("m-waterfall")) {
  class MWaterfall extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' }).innerHTML = `
        <style>
          :host {
            display: block;
            position: relative;
          }
          ::slotted(.item) {
            position: absolute;
          }
        </style>
        <div class="waterfall-container">
          <slot></slot>
        </div>
      `;
    }

    connectedCallback() {
      this.applyWaterfall();
      window.addEventListener('resize', this.applyWaterfall.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.applyWaterfall.bind(this));
    }

    applyWaterfall() {
      requestAnimationFrame(() => {
        const container = this.shadowRoot.querySelector('.waterfall-container');
        const items = this.querySelectorAll('.item');
        const containerWidth = container.clientWidth;
        const itemWidth = items[0].offsetWidth;
        const numCols = Math.floor(containerWidth / itemWidth);
        const positions = new Array(numCols).fill(0).map((_, index) => [index * itemWidth, 0]);

        items.forEach(item => {
          const minColIndex = positions.reduce((minIndex, pos, index) => pos[1] < positions[minIndex][1] ? index : minIndex, 0);
          item.style.left = `${positions[minColIndex][0]}px`;
          item.style.top = `${positions[minColIndex][1]}px`;
          positions[minColIndex][1] += item.offsetHeight;
        });

        container.style.height = `${Math.max(...positions.map(pos => pos[1]))}px`;
      });
    }
  }

  customElements.define('m-waterfall', MWaterfall);
}